module.exports = __webpack_public_path__ + "media/configurations/ZOC_O-X-X-O-693aebb2.png";